<template>
  <b-container class="video-container">
    <div class="auto-demo">
      <b-row>
        <b-col lg="7" class="col-text">
          <div class="inner">
            <h2 class="md-none">Как работает форма регистрации</h2>
            <div>
              <div class="button-a">
                <DemoModal v-bind="modal"></DemoModal>
                <!--<a href="https://promo.event-go.ru" target="_blank" class="button auto-btn">Демонстрация</a>-->
              </div>
            </div>
          </div>
        </b-col>
        <b-col lg="5" class="col-video">
          <h2 class="md-appear">Как работает форма регистрации</h2>
          <VideoModal v-bind="video"></VideoModal>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>
<script>
import VideoModal from "./video";
import DemoModal from "./demo-modal";

export default {
  components: {
    VideoModal,
    DemoModal
  },
  data() {
    return {
      modal: {
        promise: `В демонстрационном режиме вы сможете пройти все шаги регистрации <br>
        участника, попробовать инструменты редактирования персональных <br>
        данных и познакомиться с формой статистики.`,
        paragraph: `Для доступа к демо-версии стойки регистрации Вам <br>
        необходимо перейти на CRM-платформу EventGO! Напишите нам свой имеил <br>
        и мы вышлем на него необходимые ссылки.`,
        mobileParagraph: `Испытайте все возможности программы в <br>
        демонстрационном режиме и рассчитайте стоимость <br>
        автоиматизации вашей акции! Откройете эту страницу <br>
        на компьютере и вам станут доступными демо-режим <br>
        и калькулятор стоимости.`
      },
      video: {
        preview: `https://i.ytimg.com/vi/L1Sj7RHqZ8U/maxresdefault.jpg`,
        src: `https://www.youtube.com/embed/L1Sj7RHqZ8U`,
        id: `1`
      }
    };
  }
};
</script>